<template>

  <v-container>
    <v-row align="center" justify="center">
      <v-col  >
        <v-card-title class="card-title">

        </v-card-title>


        <div class="text-center" v-if="activityUnit">
          <br>
          <div class="text-h4">
          <v-icon large class="indigo--text mr-3">{{ $t('client.account.icon') }}</v-icon>
          Check-in Informations
          </div>
          <br><br>
          <span class="text-h4">{{ $t('shared.activities.titleSingle')}} : {{ title }}</span><br><br>
          <div class="text-h5">&nbsp;{{ $t('shared.activities.person') }} : {{ activityUnit.prenom }}
            {{ activityUnit.nom }}
          </div>
          <br>
          <div class="text-h5" v-if="activityUnit.file">&nbsp;{{ $t('client.account.license') }} :
            {{ activityUnit.file.name }}
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col sm="4" cols="4">
        <span v-if="!activityUnit.file">

          <v-form ref="addImageForm" lazy-validation>
             <v-file-input counter show-size accept="image/*;capture=camera" @change="onFileChange" ref="fileUpload"
                    :label="$t('client.account.license')" prepend-icon="mdi-camera"></v-file-input>
          </v-form>

        </span>

      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-card-text class="text-center" v-if="!activityUnit">

        <h1 class="mt-6 mb-3" style="font-size: 2em;">{{ $t('main.access_denied.header') }}</h1>
        <div class="text-center grey--text" v-html="$t('shared.invalidLink')"></div>

      </v-card-text>
    </v-row>
  </v-container>
</template>

<script>

import { mapGetters } from 'vuex'

import { ActivitiesApi } from '../../../shared/services/api/activities'
import moment from 'moment'
import { UsersApi } from '../../../shared/services'

export default {
  data () {
    return {
      title :"",
      activityUnit: {}
    }
  },
  components: {},
  methods: {
    onFileChange (file) {
      console.log(file)
      if (file) {
        var formData = new FormData()
        var fileName = file.name
        if (fileName == 'image.jpg') {
          fileName = moment().format('YYYY-MM-DD hh.mm.ss') + '.jpg'
        }
        formData.append('file', file, fileName)

        ActivitiesApi.activityCheckinFile(this.$route.query.uuid,formData).then(data => {
          this.activityUnit= data;
          this.$refs.addImageForm.reset()
          // succes message
          this.$root.bar.success({ message: i18n.t('shared.uploadSuccess') })
        }).catch(error => {
          this.$root.bar.error({ message: error })
        })

      }
    }
  },
  mounted:
      function () {

        ActivitiesApi.activityUnitCheckin(this.$route.query.uuid, this.$route.query.id)
            .then((data) => {
              this.activityUnit = data
              this.title = this.activityUnit.fileNameForProcessing;
            })
            .catch(error => {
              this.activityUnit = null
              console.error(error)
            })
            .finally()
      },
  computed: {
    ...mapGetters({ appName: 'main/appName', loggedUser: 'main/loggedUser' })
  }
}
</script>

<style scoped>


</style>
